import React from 'react';
import { motion } from 'framer-motion';
import { CheckCircle } from '@phosphor-icons/react';
import ServiceHero from '../components/ServiceHero/ServiceHero';
import { useTranslation } from 'react-i18next';

const ServicePageLayout = ({ title, subtitle, features, children, imageUrl, hideHero = false }) => {
  const { t } = useTranslation();

  return (
    <div className="bg-white">
      {/* Techy Hero Section */}
      {!hideHero && <ServiceHero title={title} subtitle={subtitle} />}

      {/* Main Content */}
      <div className="bg-white">
        <div className="container mx-auto px-4 py-20">
          <div>
            <h2 className="text-3xl font-bold font-heading mb-10 text-center">{t('webdesignPage.whatsIncluded')}</h2>
            <div className="grid md:grid-cols-2 lg:grid-cols-4 gap-8">
              {features.map((feature, index) => (
                <motion.div
                  key={index}
                  initial={{ opacity: 0, y: 20 }}
                  animate={{ opacity: 1, y: 0 }}
                  transition={{ duration: 0.5, delay: 0.1 + index * 0.1 }}
                  className="bg-gray-50 hover:bg-gray-100 transition-all duration-300 p-6 rounded-lg text-center shadow-sm hover:shadow-lg"
                >
                  <div className="inline-block bg-white p-4 rounded-full mb-4 ring-8 ring-gray-100">
                      <CheckCircle size={32} weight="duotone" className="text-teal-500" />
                  </div>
                  <h4 className="font-bold font-heading text-lg">{feature.title}</h4>
                  <p className="text-gray-600 text-sm">{feature.description}</p>
                </motion.div>
              ))}
            </div>
          </div>
          
          <div className="max-w-none mx-auto mt-20 text-gray-700">
            {children}
          </div>
        </div>
      </div>
    </div>
  );
};

export default ServicePageLayout; 